<template>
  <div
    class="pre-license-app"
    style="margin-left: 5%;margin-right: 5%;overflow: auto"
  >
    <el-container>
      <el-main>
        <div>
          <el-table
            v-loading="loading"
            :data="
              tableData.slice(
                (currentPage - 1) * pagesize,
                currentPage * pagesize
              )
            "
            border
            :default-sort="{ prop: 'date', order: 'descending' }"
            style="width: 100%;margin-top: 3%"
          >
            <el-table-column label="id">
              <template slot-scope="scope">
                <el-tag size="medium">{{ scope.row.id }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="批量生成数量">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.batch_num }}</span>
              </template>
            </el-table-column>
            <el-table-column label="授权功能">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.license_info.feature_name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="授权功能code">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.license_info.feature_code
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="生成时间">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">
                  {{ dateTimeFormat(scope.row.create_timestamp) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  class="btns"
                  size="mini"
                  type="success"
                  @click="downloadFun(scope.row.id)"
                  >下载
                </el-button>
                <el-button
                  class="btns"
                  size="mini"
                  type="warning"
                  @click="sendLicense(scope.row.id)"
                  >发送到邮箱
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
      <el-footer>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 40]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next"
            :total="tableData.length"
            prev-text="上一页"
            next-text="下一页"
            style="margin: auto;"
          >
          </el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { dateFormat } from "@/libs/date.js";
import User from "@/models/user";

export default {
  name: "PreLicense",
  data() {
    return {
      currentPage: 1, //默认显示页面为1
      pagesize: 10, //    每页的数据条数
      tableData: [],
      email: ""
    };
  },
  methods: {
    getEmail() {
      User.getUsers()
        .then(response => {
          this.email = response.data.user.email;
        })
        .catch(error => {
          this.$message.error(error.response.data.message);
        });
    },
    dateTimeFormat(data) {
      return dateFormat("YYYY-mm-dd HH:MM:SS", new Date(Number(data * 1000)));
    },
    downloadFun(licFileId) {
      if (licFileId) {
        location.href = location.origin + "/api/license/pre_lic/" + licFileId;
      } else {
        this.$message.error("授权文件不存在");
      }
    },
    sendLicenseApi(licFileId, email) {
      axios
        .get(`/api/license/pre_lic/${licFileId}`, {
          params: {
            isSend: true,
            email: email
          }
        })
        .then(() => {
          this.$message.success("发送成功请注意查收");
        })
        .catch(error => {
          this.$message.error(error.response.data.message);
        });
    },
    sendLicense(licFileId) {
      this.getEmail();
      this.$prompt("授权信息将发送到此邮箱，是否确定？", "确认邮箱", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: "邮箱格式不正确",
        inputValue: this.email
      })
        .then(({ value }) => {
          this.sendLicenseApi(licFileId, value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消发送"
          });
        });
    },
    // 每页下拉显示数据
    handleSizeChange(size) {
      this.pagesize = size;
    },
    // 点击第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    getPreLic() {
      axios.get("/api/license/pre_lic").then(response => {
        this.tableData = response.data;
      });
    }
  },
  created() {
    this.getPreLic();
    this.getEmail();
  }
};
</script>

<style scoped></style>
